import React, { createContext, useContext } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Create the context
const ToastContext = createContext();

// Custom hook for access
export const useToast = () => useContext(ToastContext);

// Provider component
export function ToastProvider({ children }) {
  const showToast = (message, type = 'default') => {
    toast[type](message); // types: success, error, info, warning, etc.
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <ToastContainer />
    </ToastContext.Provider>
  );
}
